import { useMemo } from 'react';
import { EnhancedScenarioResults, ChartType } from '../types';

export const useChartData = (results: EnhancedScenarioResults[], chartType: ChartType) => {
  return useMemo(() => {
    if (chartType === 'annual') {
      return results.slice(1).map(r => ({
        year: r.year,
        annualRent: r.rentScenario.annualRentReal,
        netRentalIncome: r.rentScenario.netRentalIncomeAfterTax,
        expenses: r.rentScenario.totalExpenses
      }));
    } else {
      return results.map(r => ({
        year: r.year,
        rentTotal: r.rentScenario.totalEquityReal,
        sell100: r.sellScenarios.portfolio100.totalValueReal,
        sell80_20: r.sellScenarios.portfolio80_20.totalValueReal,
        sell60_40: r.sellScenarios.portfolio60_40.totalValueReal
      }));
    }
  }, [results, chartType]);
};